import type {SuggestLocation, SuggestObject} from '@yandex-delivery/api/model/suggest'
import type {LngLatBounds} from '@yandex-delivery/blocks'

export const getPlacemarkCoords = (addressValue: SuggestObject) => addressValue.position

export const pointsToBounds = (points: SuggestLocation[]): LngLatBounds | undefined => {
  if (points.length === 0) {
    return undefined
  }
  const nonNormalizedBounds = points.reduce<LngLatBounds>(
    (acc, [longitude, latitude]) => [
      [Math.min(acc[0][0], longitude!), Math.max(acc[0][1], latitude!), 0.5],
      [Math.max(acc[1][0], longitude!), Math.min(acc[1][1], latitude!), 0.5],
    ],
    [
      //top      left
      [Infinity, -Infinity],
      //bottom   right
      [-Infinity, Infinity],
    ],
  )
  const lngAmplitude = nonNormalizedBounds[1][0] - nonNormalizedBounds[0][0]
  const latAmplitude = nonNormalizedBounds[0][1] - nonNormalizedBounds[1][1]
  const k = 0.2
  return [
    [nonNormalizedBounds[0][0] - k * lngAmplitude, nonNormalizedBounds[0][1] + k * latAmplitude],
    [nonNormalizedBounds[1][0] + k * lngAmplitude, nonNormalizedBounds[1][1] - k * latAmplitude],
  ]
}

export const isSuggestPoint = (arr: (number | undefined)[]): arr is SuggestLocation =>
  arr.length >= 2 && !!arr[0] && !!arr[1]
